var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonalInfo = function SvgPersonalInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 18.18c.502.153 1.18.153 2.333.153h8.667c1.153 0 1.83 0 2.333-.152m-13.333 0a1.824 1.824 0 0 1-.302-.12 2.5 2.5 0 0 1-1.093-1.093c-.272-.535-.272-1.235-.272-2.635V5.666c0-1.4 0-2.1.272-2.635a2.5 2.5 0 0 1 1.093-1.093c.535-.272 1.235-.272 2.635-.272h8.667c1.4 0 2.1 0 2.635.272a2.5 2.5 0 0 1 1.092 1.093c.273.535.273 1.235.273 2.635v8.667c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.092 1.826 1.826 0 0 1-.302.12m-13.333 0c0-.674.004-1.03.064-1.331a3.333 3.333 0 0 1 2.619-2.619c.322-.064.709-.064 1.483-.064h5c.775 0 1.162 0 1.484.064a3.333 3.333 0 0 1 2.619 2.619c.06.3.064.657.064 1.331M13.333 7.916a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPersonalInfo;